import type { PDDaySummary } from "../types";

export function pdDayDetailPath(sessionID: string): string {
  return `/pd-day/${encodeURIComponent(sessionID)}`;
}

export function pdDayModulesPath(sessionID: string): string {
  return `/pd-day-modules/${encodeURIComponent(sessionID)}`;
}

// Where a teacher's PD Day opens: its content page, which lists every
// module's items and continues into Module 1. A day with none (an older
// server, or nothing published) falls back to the read-only summary once it
// is over.
export function teacherPDDayPath(day: PDDaySummary, finished: boolean): string {
  if (day.modules?.length) return pdDayModulesPath(day.id);
  return finished ? `/pd-day-summary/${encodeURIComponent(day.id)}` : "/pd-days";
}

// The PD Day a module was opened from — today's delivery first, since a PD
// Day can run more than once.
export function dayForModule(days: PDDaySummary[], moduleID: string): PDDaySummary | null {
  const matches = days.filter((day) => day.modules?.some((module) => module.id === moduleID));
  return matches.find((day) => day.status === "in_progress") ?? matches[0] ?? null;
}

// "Module 1 Video", "Module 1 Quiz" — the teacher-facing name of an item in
// the PD Day flow, used instead of its authored title.
export function itemLabelKey(type: string): string {
  return type === "video"
    ? "moduleItemVideo"
    : type === "quiz"
      ? "moduleItemQuiz"
      : "moduleItemActivity";
}
